import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxGlideModule } from 'ngx-glide';
import { MatIconModule } from '@angular/material/icon';
import { EventsService, UtilService, VariablesService } from 'src/app/shared/services';
import { Router, RouterLink } from '@angular/router';
import { HealthFirstService } from '../../services/health-first.service';
import { SwiperConfigInterface, SwiperModule } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-hf-plan-info',
  standalone: true,
  imports: [
    CommonModule,
    NgxGlideModule,
    MatIconModule,
    RouterLink,
    SwiperModule
  ],
  templateUrl: './hf-plan-info.component.html',
  styleUrls: ['./hf-plan-info.component.scss']
})
export class HfPlanInfoComponent {
  @Input() plans = [];
  constructor(
    public util: UtilService,
    private hfService: HealthFirstService,
    private router: Router,
    private events: EventsService,
    private vars: VariablesService
  ) {}
  config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 7,
    initialSlide: 1,
    navigation: true,
    keyboard: true,
    scrollbar: false,
    loop: false,
    observer: true,
    preloadImages: false,
    spaceBetween: 16,
    centeredSlides: false,
    pagination: false,
    breakpoints: {
      1281: {
        slidesPerView: 6.5,  
        centeredSlides: false,
        allowTouchMove: true,
        loop: false,
        initialSlide: 0,
        observer: true,
      },
      992: {
        slidesPerView: 'auto',
        centeredSlides: false,
        allowTouchMove: true,
        loop: false,
        initialSlide: 0,
        observer: true,
      },
      768: {
        slidesPerView: 2.2,
        centeredSlides: false,
        allowTouchMove: true,
        navigation: true,
        loop: false,
        spaceBetween: 8,
        initialSlide: 0,
        observer: true,
      },
    }
  }

  onPlanClicked(item, index) {
    this.hfService.selectedBenefit = item;
    if (this.util.isMobile()) {
      this.router.navigate(['/healthfirst/plans'], {queryParams: { id: index + 1 } })
    } else {
      this.router.navigate(['/healthfirst/plans'])
    }

    this.sendEvent({
      eventName: 'benefits_clicked',
      page_name: 'healthfirst_homepage',
      info_1: this.util.stripHtml(item.info_2)
    });
    this.vars.pageName=  'healthfirst_homepage';
    this.events.claverTapPush('Healthfirst benefits clicked', {
      'Event Name': 'benefits_clicked',
      'info_1': this.util.stripHtml(item.info_2)
    })
  }

  sendEvent(payload) {
    this.events.sendSystemEvent(payload).subscribe(_ => _);
  }
}
